import { render } from "./AppAsk.vue?vue&type=template&id=1270ec2c&scoped=true"
import script from "./AppAsk.vue?vue&type=script&lang=js"
export * from "./AppAsk.vue?vue&type=script&lang=js"

import "./AppAsk.vue?vue&type=style&index=0&id=1270ec2c&scoped=true&lang=scss"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1270ec2c"]])

export default __exports__